import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  DialogActions,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function AddCustomType(props) {
  const [name, setName] = useState("");
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setName("");
    setOpen(false);
  };

  const canSubmit = Boolean(name?.trim());

  return (
    <>
      <Box
        component="span"
        onClick={props.disabled ? undefined : () => setOpen(true)}
        sx={{
          display: "flex",
          flex: 1,
          width: "100%",
          minHeight: 0,
          ...(props.disabled ? { pointerEvents: "none", cursor: "not-allowed" } : {}),
        }}
        aria-disabled={props.disabled ? "true" : undefined}
      >
        {props.children}
      </Box>
      {open && (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
          <DialogTitle>
            {props.label}
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ minHeight: "150px" }}>
            <Box pt={2}>
              <Box mb={3}>
                <Typography variant="body1" color="textSecondary">
                  Add an item type that's not included in your catalog
                </Typography>
              </Box>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    value={name}
                    label="Name"
                    name="name"
                    variant="outlined"
                    fullWidth
                    required
                    onChange={(e) => setName(e.target.value)}
                    inputProps={{ maxLength: 100 }}
                    helperText=""
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => {
                props.onChange({ name: name.trim() });
                handleClose();
              }}
              disabled={!canSubmit}
            >
              ADD OPTION
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
